import { gql } from '@apollo/client'

const SIMPLE_FOOD_MOOD_FRAGMENT = gql`
  fragment SimpleFoodMoodFragment on FoodMood {
    id
    name
    position
  }
`

export default SIMPLE_FOOD_MOOD_FRAGMENT
